<div class="header" id="hdavatar" >
    <div [attr.dpad]="DpadZoneType.HEADER" y-dpad= '0' x-dpad= '0' class="hd-logo" [routerLink]="[ROUTE_PATH.CHECK_SHEET]" [routerLinkActive]="'active'"></div>
    <div [attr.dpad]="DpadZoneType.HEADER" y-dpad= '0' x-dpad= '1'  class="hd-profile" (click)="openLogOutDialog()">
       <img class="hd-icon" src="../../../../assets/images/user_header.png"/>
       <label class="lbl_name">{{ userName }}</label>
    </div>
</div>

<caremoni-dialog-logout [isDisplayModal] = "isShowDlgLogOut"
    (closeModalHandler)="logout($event)"></caremoni-dialog-logout>
